import moment from 'moment';
import 'moment/locale/de';
import formatDurationSetUp from 'moment-duration-format';
import {createInstance} from '../i18n/i18n';

export const bootI18n = async () => {
    formatDurationSetUp(moment);
    const i18n = await createInstance();
    moment.locale(i18n.language);
    return i18n;
};



// WEBPACK FOOTER //
// ./src/boot/i18n.ts